import React from 'react';

/**
 * BrandMark — the official Luggagefreejourney brand lockup (logo + wordmark).
 *
 * Use this everywhere the brand needs to show in the UI header (Landing,
 * Dashboard, Payment, Track, Receipt, Partner, Agent, Admin, LuggageForm).
 * It keeps the logo file path centralised so swapping the asset later is a
 * one-line change.
 *
 * Props:
 *   size      logo pixel height. Defaults to 36.
 *   showText  render the LUGGAGEFREEJOURNEY wordmark next to the logo. Default true.
 *   textClass override the wordmark size; defaults to the original H1 lockup style.
 *   className optional wrapper class.
 */
export const BrandMark = ({
  size = 36,
  showText = true,
  textClass = 'text-base md:text-xl',
  className = ''
}) => (
  <div className={`flex items-center gap-2 sm:gap-3 ${className}`} data-testid="brand-mark">
    <img
      src="/lfj-logo.png"
      alt="Luggagefreejourney logo"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: 'contain', borderRadius: 6 }}
      className="shrink-0"
    />
    {showText && (
      <span
        className={`${textClass} font-black uppercase tracking-tight`}
        style={{ fontFamily: 'Cabinet Grotesk' }}
      >
        LUGGAGEFREEJOURNEY
      </span>
    )}
  </div>
);

export default BrandMark;
